import { Component, h, Host, Prop, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'signet-accordion',
  styleUrl: 'signet-accordion.scss',
})
export class Accordion implements ComponentInterface {
  /**
   * An enum prop that determines the size of the accordion component, with options for small ('sm'), medium ('md'), or large ('lg').
   */
  @Prop() size: 'sm' | 'md' | 'lg' = 'md';

  render() {
    return (
      <Host class={`signet-accordion ${this.size}`}>
        <slot />
      </Host>
    );
  }
}
